import { all } from 'redux-saga/effects'
import watchInterviewRequestsSaga from './interviewRequests'
import watchCalendarStatusSaga from './calendarStatus'
import watchCompanySaga from './company'
import watchMessagesSaga from './messages'
import watchInterviewRequestDetailsSaga from './interviewRequestDetails'

export default function* rootSaga() {
  yield all([
    watchInterviewRequestsSaga(),
    watchCalendarStatusSaga(),
    watchCompanySaga(),
    watchMessagesSaga(),
    watchInterviewRequestDetailsSaga(),
  ])
}
